import { DocumentCard } from "components/ui/DocumentCard/DocumentCard"
import { CollapseBlueIcon } from "components/ui/icons/collapseIcon/CollapseBlueIcon"
import { CollapseGrayIcon } from "components/ui/icons/collapseIcon/CollapseGrayIcon"

import type { ExpandableConfig } from "antd/es/table/interface"
import type { TQuotationTableData } from "types/quotations.type"
import type { TStopPropagation } from "types/default.type"
import type { MouseEvent } from "react"
import type { SetURLSearchParams } from "react-router-dom"
import style from "./TableQuotations.module.scss"

const { documentsWrapper } = style

export const TableQuotationsExpandable = (
	onDownload: (fileName: string, downloadLink: string, type: string, e?: TStopPropagation) => void,
	onPreview: (downloadLink: string) => void,
	setSearchParams: SetURLSearchParams,
	searchParams: URLSearchParams,
): ExpandableConfig<TQuotationTableData> => {
	return {
		expandedRowRender: (record) => (
			<div className={documentsWrapper}>
				{record.files.map((file) => (
					<DocumentCard
						key={file.id}
						file={file}
						downloadFile={(e) => onDownload(file.name, file.download_endpoint, file.type, e)}
						openFilePreview={() => onPreview(file.download_endpoint)}
					/>
				))}
			</div>
		),
		onExpand: (expanded, record) => {
			const newSearchParams = new URLSearchParams(searchParams)
			if (expanded) {
				newSearchParams.set("quotationID", String(record.key))
			} else {
				newSearchParams.delete("quotationID")
			}
			setSearchParams(newSearchParams)
		},
		expandRowByClick: true,
		expandIcon: ({ expanded, onExpand, record }) =>
			expanded ? (
				<CollapseBlueIcon rotate={90} onClick={(e) => onExpand(record, e as MouseEvent<HTMLElement>)} />
			) : (
				<CollapseGrayIcon onClick={(e) => onExpand(record, e as MouseEvent<HTMLElement>)} />
			),
	}
}
